module.exports = __webpack_public_path__ + "img/caso5.f33d1459.jpeg";